// actions/themeActions.js

import * as themeServices from '../../services/themeServices';
import { START_LOADING, STOP_LOADING } from "./actionTypes";
import { openSessionTimeoutModal } from './sessionTimeOutActions';

// Fetch user's domain
export const getUserDomainAction = (userId) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'GET_USER_DOMAIN' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await themeServices.getUserDomain(userId, token);
    dispatch({ type: STOP_LOADING, service: 'GET_USER_DOMAIN' });
    dispatch({ type: 'GET_USER_DOMAIN_SUCCESS', payload: response });
    return response;
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'GET_USER_DOMAIN' });
    dispatch({ type: 'GET_USER_DOMAIN_FAILURE', payload: error.message });
    throw error;
  }
};

// Fetch themes by domain
export const getThemesByDomainAction = (domainId) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'GET_THEMES_BY_DOMAIN' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await themeServices.getThemesByDomain(domainId, token);
    dispatch({ type: STOP_LOADING, service: 'GET_THEMES_BY_DOMAIN' });
    dispatch({ type: 'GET_THEMES_BY_DOMAIN_SUCCESS', payload: response });
    return response;
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'GET_THEMES_BY_DOMAIN' });
    dispatch({ type: 'GET_THEMES_BY_DOMAIN_FAILURE', payload: error.message });
    throw error;
  }
};

// Add theme to domain
export const addThemeToDomainAction = (domainId, themeId) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ADD_THEME_TO_DOMAIN' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    await themeServices.addThemeToDomain(domainId, themeId, token);
    dispatch({ type: STOP_LOADING, service: 'ADD_THEME_TO_DOMAIN' });
    dispatch({ type: 'ADD_THEME_TO_DOMAIN_SUCCESS' });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ADD_THEME_TO_DOMAIN' });
    dispatch({ type: 'ADD_THEME_TO_DOMAIN_FAILURE', payload: error.message });
    throw error;
  }
};

// Existing saveThemeAction, updated to return response
export const saveThemeAction = (customTheme, user, callbackfn) => async (dispatch, getState) => {
  
  try {
    alert("in save theme action");
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await themeServices.saveTheme(customTheme, user, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    if (response) {
      callbackfn && callbackfn();
    }
    dispatch({ type: 'SAVE_THEME_SUCCESS', payload: response });
    return response;
  } catch (error) {
    if ((typeof (error) !== "object" && error?.includes("403")) || (error && error.message?.includes("403"))) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'SAVE_THEME' });
      dispatch({ type: 'SAVE_THEME_FAILURE', payload: typeof (error) === "object" ? error.message : error || 'Save theme service failed. Please try again.' });
    }
    throw error;
  }
};
export const getThemeAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");;
    const response = await themeServices.getTheme(token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_THEME_SUCCESS', payload: response });
  } catch (error) {
    if((typeof(error) !== "object" && error?.includes("403")) || (error && error.message?.includes("403"))) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_THEME_FAILURE', payload: typeof(error)==="object" ? error.message : error || 'Get theme service failed. Please try again.' });
    }
  }
};

export const updateThemeAction = (id, formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");;
    const response = await themeServices.updateTheme(id, formData, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' }); 
    dispatch({ type: 'UPDATE_THEME_SUCCESS', payload: response });
  } catch (error) {
    if((typeof(error) !== "object" && error?.includes("403")) || (error && error.message?.includes("403"))) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'UPDATE_THEME_FAILUTE', payload: typeof(error)==="object" ? error.message : error || 'Update theme service failed. Please try again.' });
    }
  }
};
